import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

export interface GenericErrorProps {
  errorContent?: string | React.ReactNode;
  showBorder?: boolean;
  headerContent?: string;
}

export const GenericError: React.FC<GenericErrorProps> = ({
  errorContent,
  showBorder = true,
  headerContent,
}: GenericErrorProps) => {
  const errorEmail = 'contact@opendoor.com';

  return (
    <Col
      className={cn(
        'rounded-lg bg-od-bg-primary p-3',
        // bricks drew the border and its 0 2px 8px/10% shadow off the same flag.
        showBorder && 'border border-od-border-primary shadow-md',
      )}
    >
      <Col className="items-center gap-2">
        <Text
          as="h1"
          className="text-header-lg font-medium text-od-content-primary text-center lg:text-display-sm"
        >
          {headerContent || 'Oops, something went wrong'}
        </Text>
        {errorContent ? (
          typeof errorContent === 'string' ? (
            <Text as="p" className="text-body-md text-od-content-primary text-center">
              {errorContent}
            </Text>
          ) : (
            errorContent
          )
        ) : (
          <Col className="items-center gap-1">
            <Text as="p" className="text-body-md text-od-content-primary text-center">
              It looks like we ran into an issue. Please try again.
            </Text>
            <Text as="p" className="text-body-md text-od-content-primary text-center">
              Email us at{' '}
              <Link href={`mailto:${errorEmail}`} analyticsName="error-contact-email">
                {errorEmail}
              </Link>{' '}
              if the problem persists.
            </Text>
          </Col>
        )}
      </Col>
    </Col>
  );
};
